import React, { FC, useContext } from 'react';
import {
  FormatCurrency,
  FormatCurrencyType,
  FormatCurrencyProps,
} from 'shared/components/Format/Currency/FormatCurrency';
import { FormatCurrencies } from 'shared/components/Format/Currency/FormatCurrencies';
import { GameActivityPaymentContext } from 'modules/game-payments/providers';
import { HIGH_FORMAT_CURRENCY_PRECISION } from 'shared/utils';

type ComponentProps = Pick<FormatCurrencyProps, 'amount' | 'showZeroLabel' | 'noColor'>;

export const GameCurrency: FC<ComponentProps> = ({ ...rest }) => {
  const { paymentConfig } = useContext(GameActivityPaymentContext);

  if (!paymentConfig) {
    return null;
  }

  if (!paymentConfig.isPlatformFeeApplied) {
    return (
      <FormatCurrencies
        currency={paymentConfig.mainCurrency}
        maxPrecision={HIGH_FORMAT_CURRENCY_PRECISION}
        {...rest}
      />
    );
  }

  return (
    <FormatCurrency
      type={FormatCurrencyType.Crypto}
      currency={paymentConfig.mainCurrency}
      maxPrecision={HIGH_FORMAT_CURRENCY_PRECISION}
      {...rest}
    />
  );
};
